export default "__VITE_ASSET__TRD_cdwO__"